<section class="tw-rounded-3 tw-mx-4 tw-px-2 tw-py-3 tw-border-[2px] tw-border-solid tw-border-teal-200 tw-max-h-18 tw-box-border"
  style="background: linear-gradient(95deg, #E4F4F0 -6.23%, #FFF 88%);"
  routerLink="/user/order/{{order?.id}}" (click)="handleClick()">
  @if (shouldShowPartialOrderCancellationUI) {
    <div class="header tw-flex tw-items-center">
      <div >
        <cs-icon class="tw-h-12 tw-w-12" [iconName]="'order_packing'"></cs-icon>
      </div>
      <div class="tw-ml-2 tw-flex tw-flex-col tw-min-h-12 tw-gap-1">
        <div class="tw-flex tw-items-center tw-gap-2">
          <p class="tw-leading-[15px] tw-font-bold tw-text-gray-800 tw-text-300" i18n="@@productsPacked">{{orderedProductsCount}}/{{totalProductsCount}} Products Packed</p>
          <cs-icon class="tw-h-4 tw-w-4" [iconName]="'chevron_right_teal'"></cs-icon>
        </div>
        @if (cancelledProducts?.length === 1) {
          <p class="tw-text-200 tw-text-orange-500 tw-font-medium" i18n="@@productRemovedByYourDoctor">{{cancelledProducts?.length}} product removed by your doctor </p>
        } @else if (cancelledProducts?.length > 1) {
          <p class="tw-text-200 tw-text-orange-500 tw-font-medium" i18n="@@productsRemovedByYourDoctor">{{cancelledProducts?.length}} products removed by your doctor </p>
        }
      </div>
    </div>
  } @else {
    <div class="header tw-flex tw-items-center">
      <div >
        <cs-icon class="tw-h-12 tw-w-12" [iconName]="'order_packing'"></cs-icon>
      </div>
      <div class="tw-ml-2 tw-flex tw-flex-col tw-min-h-12 tw-gap-1">
        <div class="tw-flex tw-items-center">
          <div class="tw-leading-4 tw-font-body tw-font-bold tw-text-[14px] tw-items-center tw-flex tw-pt-1" i18n="@@packingYourOrder"
            [ngClass]="{'tw-text-[10px]': ['ta', 'te', 'ml', 'kn'].includes(user?.get('languagePreference'))}">
        Packing Your Order
      </div>
          <cs-icon class="tw-pt-1 tw-h-4 tw-w-4 tw-pl-2" [iconName]="'chevron_right_teal'"
            [ngClass]="{'tw-h-5 tw-w-5': ['ta', 'te', 'ml', 'kn'].includes(user?.get('languagePreference'))}">
          ></cs-icon>
        </div>
        @if (order?.get("type") === appConfig.Shared.Order.Type.REGIMEN) {
          <div class="tw-leading-[18px] tw-font-body tw-text-gray-500 tw-font-medium tw-text-[12px] tw-items-center tw-flex" i18n="@@packingKit"> We are packing your treatment kit </div>
        }
        @if (order?.get("type") !== appConfig.Shared.Order.Type.REGIMEN) {
          <div class="tw-leading-[18px] tw-font-body tw-text-gray-500 tw-font-medium tw-text-[12px] tw-items-center tw-flex" i18n="@@packingOrder"> We are packing your order </div>
        }

      </div>
    </div>
  }
</section>
